var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalizado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.6 11.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.08.52c-.69-.69-1.81-.69-2.5,0l-7.05,7.05L3.02,3.05c-.69-.69-1.81-.69-2.5,0-.69.69-.69,1.81,0,2.5l5.76,5.76c.35.35.8.52,1.25.52s.9-.17,1.25-.52c.03-.03.06-.06.09-.1.03-.03.07-.06.1-.09L17.08,3.02c.69-.69.69-1.81,0-2.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalizado);
export default __webpack_public_path__ + "static/media/Finalizado.3056b76f280598438b017d011fcdb303.svg";
export { ForwardRef as ReactComponent };